<template>
  <img
    v-if="name"
    :style="styles"
    :src="iconPath"
    :alt="alt"
    :class="['wptv-icon', { 'mirror': mirror, 'invert': invert, 'drop-shadow': shadow, 'opacity': opacity }]">
</template>
<script>
import ICON_CONFIG from './utils/icon.config'
import ACCESSIBILITY_CONFIG from './utils/accessibility.config'

export default {
  name: 'WptvIcon',
  props: {
    /**
     * Icon name - it matched the file in static/images/icons
     */
    name: {
      type: String,
      require: true,
      default: ''
    },
    specificAlt: {
      type: String,
      default: null
    },
    /**
     * Invert the color (used for black and white icons)
     */
    invert: {
      type: Boolean,
      default: false
    },
    /**
     * Mirror the icon (ex: arrows)
     */
    mirror: {
      type: Boolean,
      default: false
    },
    /**
     * Add a shadow
     */
    shadow: {
      type: Boolean,
      default: false
    },
    /**
     * Add an opacity
     */
    opacity: {
      type: Boolean,
      default: false
    },
    /**
     * Icon height (in px, em, rem ...)
     */
    height: {
      type: String,
      default: '1em'
    },
    /**
     * Icon width (in px, em, rem ...)
     */
    width: {
      type: String,
      default: '1em'
    }
  },
  data () {
    return {
      styles: {
        height: this.height,
        width: this.width
      }
    }
  },
  computed: {
    iconPath () {
      return `${ICON_CONFIG.ICON_PATH}${this.name}.svg`
    },
    alt () {
      return this.specificAlt || this.specificAlt === '' ? this.specificAlt : ACCESSIBILITY_CONFIG[this.name] || this.name
    }
  }
}
</script>

<style scoped lang="scss">
  @import '../../scss/abstracts/variables';

  .wptv-icon {
    display: inline-block;
    vertical-align: middle;
    position: relative;

    &.invert {
      filter: invert(1);
    }

    &.opacity {
      opacity: 0.5;
    }

    &.drop-shadow {
      filter: drop-shadow(2px 4px 2px #000);
    }

    &.invert.drop-shadow {
      filter: invert(1) drop-shadow(2px 4px 2px #000);
    }

    &.mirror {
      transform: rotate(180deg);
    }
  }

  // Parent style
  .wptv-button.orange:active,
  .wptv-button.orange:active:hover,
  .wptv-button.orange-alt:hover,
  .wptv-button.transparent-alt:hover,
  .wptv-button.black:hover,
  .wptv-button.orange,
  .wptv-button.orange-alt,
  .wptv-button.transparent-alt,
  .wptv-button.orange-alt:active,
  .wptv-button.orange-alt:active:hover,
  .wptv-button.white:hover,
  .wptv-button.white:active,
  .wptv-button.white:active:hover,
  .wptv-button.black,
  .wptv-button.black:active,
  .wptv-button.black:active:hover,
  .wptv-button.transparent-alt:active,
  .wptv-button.transparent-alt:active:hover,
  .wptv-button.transparent:hover,
  .wptv-button.transparent:active,
  .wptv-button.transparent:active:hover {
    .wptv-icon {
      filter: invert(1);
    }
  }
</style>
